import { hebrewLetters } from "../configs/config";

export interface SectionLetterSource {
  question_letter?: string | null;
  question_index?: number | string | null;
  question_letter_key?: string | null;
}

/**
 * Resolves the Hebrew section letter (א, ב, ג...) from various section metadata sources.
 *
 * Resolution Order:
 * 1. Direct Hebrew letter if present and non-empty ('א', 'ב')
 * 2. 1-based question_index mapped via hebrewLetters array (1 -> 'א', 2 -> 'ב')
 * 3. Extracted number from question_letter_key (e.g. 'section_3' -> 'ג')
 * 4. Fallback string (defaults to empty string)
 */
export const resolveSectionLetter = (
  source?: SectionLetterSource | null,
  fallback: string = ""
): string => {
  if (!source) return fallback;

  // 1. Direct Hebrew letter if explicitly specified
  if (
    source.question_letter &&
    typeof source.question_letter === "string" &&
    source.question_letter.trim()
  ) {
    return source.question_letter.trim();
  }

  // 2. 1-based question index (e.g. 1 -> 'א', 2 -> 'ב')
  const idx = Number(source.question_index);
  if (!isNaN(idx) && idx >= 1 && idx <= hebrewLetters.length) {
    return hebrewLetters[idx - 1];
  }

  // 3. Question letter key (e.g. 'section_3' -> 3 -> 'ג')
  if (source.question_letter_key) {
    const match = String(source.question_letter_key).match(/\d+/);
    if (match) {
      const keyIdx = parseInt(match[0], 10);
      if (!isNaN(keyIdx) && keyIdx >= 1 && keyIdx <= hebrewLetters.length) {
        return hebrewLetters[keyIdx - 1];
      }
    }
  }

  return fallback;
};

export default resolveSectionLetter;
